import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=05d0968f&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=05d0968f&prod&lang=scss&scoped=true"
import style1 from "./NewsView.vue?vue&type=style&index=1&id=05d0968f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0968f",
  null
  
)

export default component.exports